let captured=null;
export function captureOrganizationInvitation(location,history){
 if(location?.pathname!=='/organization-invitation')return null;
 const params=new URLSearchParams((location.hash||'').replace(/^#/,'')),ids=params.getAll('id'),tokens=params.getAll('token');
 const result=ids.length===1&&tokens.length===1&&/^invite_[a-f0-9]{64}$/.test(ids[0])&&/^[A-Za-z0-9_-]{43}$/.test(tokens[0])?{invitationId:ids[0],token:tokens[0]}:null;
 history.replaceState(null,'','/organization-invitation');return result;
}
export function prepareOrganizationInvitation(){if(typeof window!=='undefined')captured=captureOrganizationInvitation(window.location,window.history);}
export const getOrganizationInvitation=()=>captured;
export const forgetOrganizationInvitation=()=>{captured=null;};
